export default "__VITE_ASSET__P1HK8SGS__"